import { FormValue, Question } from '@app/types';
import { Button } from '@components/form/button';
import { ReactElement } from 'react';

interface Type1Props {
  group: {
    key: string;
  };
  g: {
    key: string;
    options: Question[];
  };
  values: Record<string, FormValue>;
  setFieldValue: (key: string, value: string) => void;
}

export const Type1 = ({ group, g, values, setFieldValue }: Type1Props): ReactElement => {
  return (
    <div className="type-1-questionnaire">
      {g.options[0].options?.map((item) => (
        <Button
          key={`${g.key}_${item.key}`}
          title={item.label}
          onClick={() => setFieldValue(group.key, item.key)}
          type={values[group.key] === item.key ? 'primary' : 'secondary'}
        />
      ))}
    </div>
  );
};
